import { render, staticRenderFns } from "./BackTopTop.vue?vue&type=template&id=0406a4ab&scoped=true&"
import script from "./BackTopTop.vue?vue&type=script&lang=js&"
export * from "./BackTopTop.vue?vue&type=script&lang=js&"
import style0 from "./BackTopTop.vue?vue&type=style&index=0&id=0406a4ab&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0406a4ab",
  null
  
)

export default component.exports